import { formatToMills } from 'infras/datetime';
import { useRouter } from 'next/router';
import { ProjectEventListItem } from 'presentations/api/schema/project/project_event';
import { apiPath } from 'presentations/routes/path';
import { useRequest } from 'presentations/views/hooks/request';
import { useCallback, useMemo, useState } from 'react';
import { Props } from './types';

export const useConfirmRequestButton = (props: Props) => {
  const router = useRouter();
  const eventsRequest = useRequest(
    router.isReady && props.viewer.team && props.startedAt && props.endedAt
      ? apiPath(`/v1/teams/${props.viewer.team.uid}/users/schedules`, {
          started: formatToMills(props.startedAt),
          ended: formatToMills(props.endedAt),
          userId: [props.viewer.uid],
          seminarFilter: 'grouping',
          isIncludeCalendar: 1,
          isIncludeDeclined: 0,
          includeReservedEvent: 1,
          isMergeSameIntegratedEvent: 0,
        })
      : null,
  );
  const events: ProjectEventListItem[] = eventsRequest.data || [];
  const duplicateScheduleEvents = useMemo(() => {
    const duplicateEvents = [];
    for (const userEvent of events) {
      for (const mergedEvent of userEvent.events) {
        if (props.eventUid && props.eventUid !== mergedEvent.event.uid) {
          duplicateEvents.push(mergedEvent.event);
        }
      }
    }

    return duplicateEvents;
  }, [events]);

  const [
    isOpenConfirmRequestAcceptDialog,
    setOpenConfirmRequestAcceptDialog,
  ] = useState(false);
  const [
    isOpenConfirmRequestDeclineDialog,
    setOpenConfirmRequestDeclineDialog,
  ] = useState(false);

  const onClickAcceptButton = useCallback(() => {
    setOpenConfirmRequestAcceptDialog(true);
    setOpenConfirmRequestDeclineDialog(false);
  }, []);

  const onClickDeclineButton = useCallback(() => {
    setOpenConfirmRequestAcceptDialog(false);
    setOpenConfirmRequestDeclineDialog(true);
  }, []);

  const onClickCancelDialog = useCallback(() => {
    setOpenConfirmRequestAcceptDialog(false);
    setOpenConfirmRequestDeclineDialog(false);
  }, []);

  const onClickSubmitAcceptButton = useCallback(() => {
    props.onClickAcceptRequest();
    setOpenConfirmRequestAcceptDialog(false);
    setOpenConfirmRequestDeclineDialog(false);
  }, []);

  const onClickSubmitDeclineButton = useCallback(() => {
    props.onClickDeclineRequest();
    setOpenConfirmRequestAcceptDialog(false);
    setOpenConfirmRequestDeclineDialog(false);
  }, []);

  return {
    state: {
      duplicateScheduleEvents,
      isOpenConfirmRequestAcceptDialog,
      isOpenConfirmRequestDeclineDialog,
    },
    actions: {
      onClickAcceptButton,
      onClickDeclineButton,
      onClickCancelDialog,
      onClickSubmitAcceptButton,
      onClickSubmitDeclineButton,
    },
  };
};
